export const shortenedLink = (title: string) => {
  return `<a class="shortened-link" data-title="${title}">${title}</a>` // 描画後にhrefや中身を(再)代入する
}
